import { render, staticRenderFns } from "./PdfViewer.vue?vue&type=template&id=ab01101a&scoped=true&"
import script from "./PdfViewer.vue?vue&type=script&lang=js&"
export * from "./PdfViewer.vue?vue&type=script&lang=js&"
import style0 from "./PdfViewer.vue?vue&type=style&index=0&id=ab01101a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab01101a",
  null
  
)

component.options.__file = "PdfViewer.vue"
export default component.exports